export function ComingSoon() {
  return (
    <div className='flex flex-col items-center gap-4 text-center'>
      <h2 className='text-2xl font-semibold text-[var(--color-text-primary)]'>
        Ahoy Desktop is coming soon
      </h2>
      <p className='max-w-md text-[var(--color-text-secondary)]'>
        We are polishing the final build. Check back here in a few days.
      </p>
    </div>
  );
}
